module.exports = __webpack_public_path__ + "static/media/closeBot.bfb20d94.wav";